const state = {
  name: '',
  role: '',
};

const mutations = {
  setUser(state, payload) {
    state.name = payload.name || '';
    state.role = payload.role || '';
  },
};

const actions = {
  setUser({ commit }, user) {
    commit('setUser', user);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
